import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const CTASection = () => {
  return (
    <section className="py-20 px-4 bg-blue-900">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-white mb-6">
          Ready to Transform Your Institution?
        </h2>
        <p className="text-xl text-blue-100 mb-8">
          Let's discuss how we can help your educational institution thrive in the 
          digital age. Schedule a free consultation with our education industry experts.
        </p>
        <Link to="/contact">
          <Button size="lg" className="bg-white text-blue-900 hover:bg-gray-100">
            Get Started Today
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </Link>
      </div>
    </section>
  );
};